import React, { createContext, useContext, useMemo, useState } from 'react';

// TEMPORARY compatibility file — minimal i18n stub so the app compiles.
// Keys resolve to '' (falsy) so `{t.foo || "fallback"}` works and React never
// tries to render a nested Proxy object (which caused the white screen).

const LanguageContext = createContext(null);

function createTranslations() {
  return new Proxy(
    {},
    {
      get(_target, prop) {
        if (prop === '__esModule') return false;
        if (typeof prop === 'symbol') return undefined;
        if (prop === 'then' || prop === '$$typeof') return undefined;
        if (prop === 'toJSON') return () => ({});
        // Falsy string → || fallbacks work; nested t.a.b becomes undefined safely
        return '';
      },
    }
  );
}

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('en');
  const translations = useMemo(() => createTranslations(), []);

  const value = useMemo(
    () => ({
      language,
      currentLanguage: language,
      translations,
      changeLanguage: (code) => setLanguage(code || 'en'),
    }),
    [language, translations]
  );

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    return {
      language: 'en',
      currentLanguage: 'en',
      translations: createTranslations(),
      changeLanguage: () => {},
    };
  }
  return ctx;
}

export default LanguageContext;
